import JoinGame from "./JoinGame";
import useTranslation from "next-translate/useTranslation";
import { useLobby, setTab } from "../../redux/lobby";
import {
  LIVE_GAME_TAB,
  DAILY_GAMES_TAB,
  CREATE_GAME_TAB,
} from "@chesshotel/constants";
import CActive from "./daily/CActive";
import { useDaily } from "../../redux/daily";
import { UserDailyGame } from "@chesshotel/types";
import { useEffect } from "react";
import CreateGame from "./CreateGame";
import Tabs from "./Tabs";
import PlayersOnline from "./PlayersOnline";
import { useWsConnection } from "@/redux/wsConnection";

export default function LobbyBody({ isDesktop }) {
  const { t } = useTranslation("common");
  const { t: lobbyT } = useTranslation("lobby");

  const { invites, tab } = useLobby();
  const { games } = useDaily();
  const { wsConnected } = useWsConnection();

  const gameArr = Object.values(games);
  let myTurnGames = 0;

  const nrInvites = invites.length;

  gameArr.forEach((game: any) => {
    if (game.turn && game.resultId == null) {
      myTurnGames++;
    }
  });
  const onGoingGames = gameArr.filter(
    (game: UserDailyGame) => game.resultId == null
  );

  const hasGames = onGoingGames.length != 0;

  // Desktop: 1 tab (Live) without games, 2 tabs (Live, Games) with games
  // Mobile: 2 tabs (Create, Live) without games, 3 tabs (Create, Live, Games) with games
  let nrTabs = isDesktop ? 1 : 2;
  if (hasGames) {
    nrTabs = isDesktop ? 2 : 3;
  }

  useEffect(() => {
    // On desktop, redirect CREATE_GAME_TAB to LIVE_GAME_TAB
    if (isDesktop && tab == CREATE_GAME_TAB) {
      setTab(LIVE_GAME_TAB);
    }
  }, [isDesktop]);

  useEffect(() => {
    // If no games and on DAILY_GAMES_TAB, redirect to LIVE_GAME_TAB
    if (!hasGames && tab == DAILY_GAMES_TAB) {
      setTab(LIVE_GAME_TAB);
    }
  }, [hasGames]);

  function renderSelectedTab() {
    if (tab === CREATE_GAME_TAB) {
      return <CreateGame isDesktop={isDesktop} />;
    } else if (tab === LIVE_GAME_TAB) {
      return <JoinGame />;
    } else if (tab === DAILY_GAMES_TAB) {
      return <CActive />;
    }
  }

  function handleCreate() {
    setTab(CREATE_GAME_TAB);
  }

  function handleLive() {
    setTab(LIVE_GAME_TAB);
  }

  function handleGames() {
    setTab(DAILY_GAMES_TAB);
  }

  return (
    <div className="flex justify-center w-full border border-b-[3px] rounded-b-md rounded-t-xl bg-white h-[518px] md:h-[488px]">
      <div className="flex relative flex-col items-center w-full">
        <Tabs nrTabs={nrTabs}>
          {!isDesktop && (
            <Tabs.Tab
              mobile
              selected={tab === CREATE_GAME_TAB}
              nrTabs={nrTabs}
              onClick={handleCreate}
            >
              {t("Create")}
            </Tabs.Tab>
          )}

          <Tabs.Tab
            selected={tab === LIVE_GAME_TAB}
            nrTabs={nrTabs}
            onClick={handleLive}
          >
            {lobbyT("Join game")}
            {nrInvites > 0 && tab !== LIVE_GAME_TAB && (
              <div className="flex absolute top-0 right-0 bottom-0 justify-center items-center my-auto w-5 h-5 text-white rounded-lg -translate-x-1/2 md:hidden bg-altblue-300 md:w-6 md:h-6">
                {nrInvites}
              </div>
            )}
          </Tabs.Tab>
          {hasGames && (
            <Tabs.Tab
              selected={tab === DAILY_GAMES_TAB}
              nrTabs={nrTabs}
              onClick={handleGames}
            >
              {t("Games")}
              {myTurnGames > 0 && tab !== DAILY_GAMES_TAB && (
                <div className="flex absolute top-0 right-0 bottom-0 justify-center items-center my-auto w-5 h-5 text-white bg-red-300 bg-opacity-80 rounded-lg -translate-x-1/2 md:w-6 md:h-6">
                  {myTurnGames}
                </div>
              )}
            </Tabs.Tab>
          )}
        </Tabs>
        <div className="overflow-hidden w-full min-h-0 flex-1">
          {wsConnected ? (
            renderSelectedTab()
          ) : (
            <div className="flex justify-center items-center h-full">
              <span className="loader"></span>
            </div>
          )}
        </div>
        <div className="flex absolute bottom-0 z-10 pb-4 w-full bg-white md:hidden">
          {wsConnected && <PlayersOnline />}
        </div>
      </div>
    </div>
  );
}
